import {
  AudioHighlightMetadata,
  KeywordSummaryAudioHighlightMetadata,
  ReasonSummaryAudioHighlightMetadata,
} from '@modules/feedback/components/AudioType/types';
import { isSummaryHighlightMetadataType } from '@modules/feedback/components/AudioType/utils';

export const getSummaryHighlightMetadataMatches = (
  highlightMetadata: AudioHighlightMetadata[],
  highlight:
    | KeywordSummaryAudioHighlightMetadata
    | ReasonSummaryAudioHighlightMetadata,
) => {
  const filteredHighlightMetadata = highlightMetadata.filter(
    (
      highlightMatch,
    ): highlightMatch is
      | KeywordSummaryAudioHighlightMetadata
      | ReasonSummaryAudioHighlightMetadata => {
      const hasSameTime =
        highlightMatch.startTime === highlight.startTime &&
        highlightMatch.endTime === highlight.endTime;
      const isSummaryType = isSummaryHighlightMetadataType(highlight);
      return hasSameTime && isSummaryType;
    },
  );

  const summaryTextHighlightMap = new Map<
    string,
    (
      | KeywordSummaryAudioHighlightMetadata
      | ReasonSummaryAudioHighlightMetadata
    )[]
  >();

  filteredHighlightMetadata.forEach((highlightMatch) => {
    const matches =
      summaryTextHighlightMap.get(highlightMatch.summaryText) ?? [];
    matches.push(highlightMatch);
    summaryTextHighlightMap.set(highlightMatch.summaryText, matches);
  });

  return Array.from(summaryTextHighlightMap.values()).flat();
};
